import { styled, Checkbox as Checkbox$1, checkboxClasses } from "@mui/material";
const Checkbox = styled(Checkbox$1)(({ theme }) => ({
  paddingRight: 0,
  marginRight: theme.spacing(2),
  width: theme.spacing(3),
  height: theme.spacing(3),
  [`&.${checkboxClasses.root}`]: {
    paddingRight: 0,
    "&.Mui-checked": {
      color: theme.palette.primary.main
    }
  }
}));
Checkbox.defaultProps = {
  color: "primary",
  disableRipple: true
};
export {
  Checkbox
};
